import { businessConfig } from '../../../config/businessConfig';

export default function About() {
  return (
    <section className="section about" id="historia">
      <div className="container about__grid">
        <div>
          <p className="eyebrow">Nuestra esencia</p>
          <h2 className="section-title">Un momento que también es para ti.</h2>
        </div>
        <div className="about__content">
          <p className="about__intro">
            {businessConfig.businessName} nace en {businessConfig.foundedYear} desde la admiración por el mundo de la belleza y la búsqueda de un espacio de trabajo más flexible.
          </p>
          <p>
            {businessConfig.founderName} entrega una atención personalizada y dedicada, cuidando cada detalle y priorizando la satisfacción y la calidad por sobre la cantidad de clientas atendidas.
          </p>
          <div className="about__values" aria-label="Valores de Mujer Virtuosa">
            {['Relajación', 'Confidencialidad', 'Cuidado personal', 'Amor propio'].map((value) => <span key={value}>{value}</span>)}
          </div>
        </div>
      </div>
    </section>
  );
}
